/* AVRA_VARIANT_IMAGE (2026-10-08)
   Swap the main product photo to the metal the shopper picks.

   WHY THIS EXISTS. The PDP's own variant handler updates price, SKU, the
   certificate line and the Shop Pay terms field, but it never touched the
   gallery - so choosing White Gold left a yellow gold photo on screen. The
   images themselves are ordinary Shopify variant images, assigned per metal
   in the admin, so this file only has to react to them. It invents nothing.

   It reads /products/<handle>.js rather than parsing the page, so it always
   agrees with what Shopify actually has assigned. Products with no metal
   option, or whose variants carry no image, are left completely alone.

   Delete this file and its <script> tag in sections/avra-product-
   recommendations.liquid and the PDP behaves exactly as it did before. */
(function () {
  'use strict';

  var METAL_NAMES = ['metal', 'jewelry material', 'materials'];

  function init() {
    var wrap = document.querySelector('.pdp__media');
    if (!wrap) return;
    var hero = wrap.querySelector('image-slot img') || wrap.querySelector('img');
    if (!hero) return;

    var swatches = document.querySelectorAll('.pdp__swatch[data-option-value]');
    if (!swatches.length) return;

    var path = window.location.pathname.split('/products/')[1];
    if (!path) return;
    var handle = path.split('/')[0].split('?')[0].split('#')[0];

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.options || !p.variants) return;

        var idx = -1;
        for (var i = 0; i < p.options.length; i++) {
          var nm = (p.options[i] && p.options[i].name ? p.options[i].name : p.options[i]) || '';
          if (METAL_NAMES.indexOf(String(nm).toLowerCase().trim()) !== -1) { idx = i; break; }
        }
        if (idx === -1) return;

        /* metal value -> its variant image. First variant wins; lengths and
           carats of the same metal all share one photo. */
        var byMetal = {};
        p.variants.forEach(function (v) {
          var val = v.options && v.options[idx];
          if (!val || byMetal[val] || !v.featured_image || !v.featured_image.src) return;
          byMetal[val] = v.featured_image;
        });
        if (!Object.keys(byMetal).length) return;

        function swap(value) {
          var fi = byMetal[value];
          if (!fi) return;
          var src = fi.src;
          if (!src) return;
          if (hero.getAttribute('src') === src) return;
          /* srcset would override src, so it goes before the swap. */
          hero.removeAttribute('srcset');
          hero.removeAttribute('sizes');
          hero.setAttribute('src', src);
          if (fi.alt) hero.setAttribute('alt', fi.alt);

          /* Keep the thumbnail strip honest: light up the matching thumb if
             this image is in it, otherwise clear the active state rather than
             leaving a thumb highlighted that is not what is on screen. */
          var file = src.split('/').pop().split('?')[0];
          var matched = false;
          document.querySelectorAll('.pdp__thumb').forEach(function (t) {
            var ts = t.getAttribute('data-thumb-src') || '';
            var on = ts.indexOf(file) !== -1;
            t.classList.toggle('is-active', on);
            if (on) matched = true;
          });
          if (!matched) {
            document.querySelectorAll('.pdp__thumb.is-active').forEach(function (t) {
              t.classList.remove('is-active');
            });
          }
        }

        swatches.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var v = btn.getAttribute('data-option-value') || (btn.textContent || '').trim();
            /* after the theme's own handler has run */
            window.setTimeout(function () { swap(v); }, 0);
          });
        });

        /* Respect the metal already selected on load (a shared link can land
           on a White Gold variant). */
        var current = document.querySelector('.pdp__swatch.is-active, .pdp__swatch.is-selected, .pdp__swatch[aria-pressed="true"]');
        if (current) {
          swap(current.getAttribute('data-option-value') || (current.textContent || '').trim());
        }
      })
      .catch(function () { /* leave the gallery exactly as rendered */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
